<template>
  <div class="d-flex flex-column w-100 h-100 justify-content-center align-items-center">
    <div
      class="p-4 p-lg-5"
      style="max-width:480px;"
    >
      <img
        src="@/assets/images/illustration/undraw_blank_page.svg"
        alt=""
        class="w-100"
      >
    </div>
    <div class="font-size-md text-center">
      <div v-html="$t('errorMessageFinal')" />
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  }
};
</script>
